import Result from "./components/result";

function HomePage(): React.JSX.Element {
  return <Result />;
}

export default HomePage;
